<template>
    <footer v-if="selectedHeliCounter > 0" class="dashboard-footer" :style="{ background: linearGradientStyle }">
      <section :style="{ background: linearGradientStyle }">
        <div class="footerContainer">
          <!-- Buttons for each selected helicopter -->
          <div class="selectionContainer">
            <!-- Navigation Button for Previous -->
            <div v-if="showPreviousButton" class="navButton">
              <button class="btn hollow block" @click="showPrevious">
                <
              </button>
            </div>
            <template v-for="heli in visibleHelicopters">
              <div class="buttonHeader">
                <v-chip class="dashboardFooterSerial">{{ heli.serial }}</v-chip>
              </div>
            </template>
            <!-- Navigation Button for Next -->
            <div v-if="showNextButton" class="navButton">
              <button class="btn hollow block" @click="showNext">
                >
              </button>
            </div>
          </div>
  
          <div class="buttonFooter">
            <template class="rightButtonBlock">
              <div v-if="isAHAdmin && selectedHeliCounter == 1 && !getSelectedDetailed[0].banned" class="buttonHeader">
                <button class="btn hollow block" @click="activateBannedModal()">
                  {{ $t('global.button_ban_hc') }}
                </button>
              </div>
  
              <div v-if="isAHAdmin && selectedHeliCounter == 1 && getSelectedDetailed[0].banned" class="buttonHeader">
                <button class="btn hollow block" @click="activateUnbannedModal()">
                  {{ $t('global.button_unban_hc') }}
                </button>
              </div>
  
              <div v-if="isAHAdmin" class="buttonHeader">
                <button class="btn hollow block" @click="activateRemoveHCModal()">
                  {{ $t('global.button_remove_hc') }}
                </button>
              </div>
  
              <div class="buttonHeader">
                <button class="btn hollow block" @click="activateRetrieveModal()">
                  {{ $t('global.button_download_data') }}
                </button>
              </div>
  
              <div v-if="isAdmin" class="buttonHeader">
                <button class="btn hollow block" @click="activateUploadModal()">
                  {{ $t('global.button_upload_data') }}
                </button>
              </div>
            </template>
          </div>
        </div>
  
        <modal :title="uploadFilesModal.title" :modalName="uploadFilesModal.name" width="700px"  height="550px">
          <ModalUploadFiles @responseSuccess="modalResponseSuccess" @responseError="modalResponseError" />
        </modal>
        <modal :title="retrieveModal.title" :modalName="retrieveModal.name" width="774px" height="600px">
          <ModalRetrieve :multi="true" :helicopters="getSelectedDetailed" @downloadSuccess="modalDownloadSuccess" @responseError="modalResponseError" />
        </modal>
        <modal :modalName="removeHCModal.name">
          <ModalConfirm
          :message="getSelectedAircraftMsgForDeletion"
          :useHTML="true"
          :cancel="true"
          @modalConfirmed="deleteSelectedAircraft()"
          />
        </modal>
        <modal :title="banHCModal.title" :modalName="banHCModal.name" width="460px">
          <ModalBanHC :getSelectedDetailed="banHCModal.props" @responseSuccess="modalResponseSuccess" @responseError="modalResponseError" />
        </modal>
        <modal :title="unbanHCModal.title" :modalName="unbanHCModal.name" width="460px">
          <ModalUnbanHC :getSelectedDetailed="unbanHCModal.props" @responseSuccess="modalResponseSuccess" @responseError="modalResponseError" />
        </modal>
        <modal :modalName="confirmModal.name">
          <ModalConfirm :message="confirmModal.message" :error="confirmModal.error" @modalConfirmed="closeModal()" />
        </modal>
        <modal :modalName="downloadModal.name">
          <ModalDownload :message="downloadModal.message" :downloadUrl="downloadModal.downloadUrl" @modalDownloadConfirmed="closeModal()" />
        </modal>
      </section>
    </footer>
  </template>
  
  <script>
  import { mapState, mapActions, mapGetters } from 'vuex'
  import bus from '../event/bus'
  import Modal from '../components/modals/Modal'
  import ModalUploadFiles from './modals/ModalUploadFiles'
  import ModalConfirm from './modals/ModalConfirm'
  import ModalDownload from './modals/ModalDownload'
  import ModalRetrieve from './modals/ModalRetrieve'
  import ModalBanHC from './modals/ModalBanHC'
  import ModalUnbanHC from './modals/ModalUnbanHC'
  import utils from '../mixins/utils'
  
  export default {
    name: 'DashboardFooter',
    components: {
      Modal,
      ModalUploadFiles,
      ModalConfirm,
      ModalRetrieve,
      ModalBanHC,
      ModalUnbanHC,
      ModalDownload
    },
    mixins: [utils],
    data() {
      return {
        filterData: '',
        placeholder: 'global.search_placeholder',
        uploadFilesModal: {
          name: 'ModalUploadFiles',
          title: 'uploadModal.title'
        },
        retrieveModal: {
          name: 'ModalRetrieve',
          title: 'retrieveModal.title'
        },
        removeHCModal: {
          name: 'ModalRemoveHC',
          title: 'removeHCModal.title'
        },
        banHCModal: {
          name: 'ModalBanHC',
          title: 'banHCModal.title'
        },
        unbanHCModal: {
          name: 'ModalUnbanHC',
          title: 'unbanHCModal.title'
        },
        confirmModal: {
          name: 'confirmRetreive',
          message: '',
          error: false
        },
        downloadModal: {
          name: 'downloadModal',
          message: '',
          downloadUrl: ''
        },
        currentIndex: 0,
        itemsPerPage: 6
      }
    },
    computed: {
      ...mapState(['userStore']),
      ...mapGetters('fleetStore', [
        'areAllFleetAdded',
        'isAnyActiveSelection',
        'selectedHeliCounter',
        'getSelectedDetailed'
      ]),
      ...mapGetters('userStore', ['isAdmin', 'isAHAdmin']),
      linearGradientStyle() {
        const startColor = window.env.VUE_APP_BACKGROUND_1
        const endColor = window.env.VUE_APP_BACKGROUND_2
        return `linear-gradient(to left, ${startColor}, ${endColor})`
      },
      visibleHelicopters() {
        const start = this.currentIndex;
        const end = start + this.itemsPerPage;
        return this.getSelectedDetailed.slice(start, end);
      },
      showPreviousButton() {
        return this.currentIndex > 0;
      },
      showNextButton() {
        return this.currentIndex + this.itemsPerPage < this.selectedHeliCounter;
      },
      getSelectedAircraftMsgForDeletion() {
        let heli_line = (heli) => `${this.cleanData(heli.display_type)}/${heli.serial} : ${heli.registration}`;

        let message = '';
        if (this.getSelectedDetailed.length > 1) {
          message = this.$t('removeHCModal.sub_title_1');
        }
        else {
          message = this.$t('removeHCModal.sub_title_2');
        }

        let res = `
        <div class='modal-confirm-message'>
        <div>${message}</div>
        <ul class='modal-confirm-list'>
        <li>${this.getSelectedDetailed.map(heli => heli_line(heli)).join('</li><li>')}</li>
        </ul>
        </div>`;

        return res;
      }
    },
    watch: {
      selectedHeliCounter(newVal) {
        if (newVal < this.itemsPerPage) {
          this.currentIndex = 0;
        }
      }
    },
    methods: {
      ...mapActions('appStore', ['openModal', 'closeModal']),

      // Returns true if the selected aircraft all have the same types, or if none are selected.
      aircraftSelectionHasSameType() {
        let onlyOneType = true;
        let selectedHelicopers = this.getSelectedDetailed.map(h => ({
          registration: h.registration,
          serial: h.serial,
          type: h.type
        }));
        if (this.selectedHeliCounter > 1) {
          let hcTypeValueToVerify = selectedHelicopers[0].type;
          for (let i = 0; i < this.selectedHeliCounter; i++) {
            if (selectedHelicopers[i].type !== hcTypeValueToVerify) {
              onlyOneType = false;
              break;
            }
          }
        }
        return onlyOneType;
      },
      activateAddHCModal() {
        this.openModal(this.addHCModal.name);
      },
      activateUploadModal() {
        if (this.aircraftSelectionHasSameType()) {
          this.openModal(this.uploadFilesModal.name);
        } else {
          let msg = this.$t('global.upload_modal_error');
          this.modalResponseError(msg);
        }
      },
      activateBannedModal() {
        this.openModal(this.banHCModal.name);
      },
      activateUnbannedModal() {
        this.openModal(this.unbanHCModal.name);
      },
      activateRetrieveModal() {
        if (this.aircraftSelectionHasSameType()) {
          this.openModal(this.retrieveModal.name);
        } else {
          let msg = this.$t('global.error_different_aircraft_types');
          this.modalResponseError(msg);
        }
      },
      activateRemoveHCModal() {
        this.openModal(this.removeHCModal.name);
      },
      modalResponseSuccess(msg) {
        this.confirmModal.error = false;
        this.confirmModal.message = msg || this.confirmModal.message;
        this.closeModal();
        this.openModal(this.confirmModal.name);
      },
      modalDownloadSuccess (param) {
        this.downloadModal.message = param.message
        this.downloadModal.downloadUrl = param.downloadUrl
        this.closeModal()
        this.openModal(this.downloadModal.name)
      },
      modalResponseError(errorMsg) {
        this.confirmModal.error = true;
        this.confirmModal.message = errorMsg;
        this.closeModal();
        this.openModal(this.confirmModal.name);
      },
      showPrevious() {
        if (this.currentIndex > 0) {
          this.currentIndex -= this.itemsPerPage;
        }
      },
      showNext() {
        if (this.currentIndex + this.itemsPerPage < this.selectedHeliCounter) {
          this.currentIndex += this.itemsPerPage;
        }
      },
      deleteSelectedAircraft() {
        let formData = new FormData()
        let selectedHelicopers = this.getSelectedDetailed.map(h => {
          return {
            registration: h.registration,
            serial: h.serial,
            type: h.type
          }
        });
        formData.append(
          'selected_helicopters',
          JSON.stringify(selectedHelicopers)
        );

        this.$requester
        .post('/remove', formData, {
          responseType: 'blob'
        })
        .then(response => {
          bus.$emit('refreshDashboardEvt', 'Aircraft successfully removed');
          this.closeModal();
        })
        .catch(error => {
          if (error.response) {    
            let errMsg = this.$t('errorMsg.err')
            this.modalResponseError(`${errMsg}`);
          }
        });
      }
    }
  };
  </script>
  
  <style scoped lang="scss">
  .dashboard-footer {
    position: fixed;
    bottom: 0;
    width: calc(100% - 190px);
    z-index: 1000; /* Ensure it appears above other content */
  }
  
  .footerContainer {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
  }
  
  .selectionContainer {
    display: flex;
    align-items: center;
    height: 50px;
    flex-grow: 1; /* Allow this container to grow and take available space */
  }
  
  .buttonFooter {
    display: flex;
    align-items: center;
    height: 50px;
    flex-grow: 0; /* Ensure this container does not grow and stays to the right */
  }
  
  .navButton {
    display: flex;
    align-items: center;
    height: 50px;
  }

  .dashboardFooterSerial {
    pointer-events: none;
  }

  </style>